/* istanbul ignore file */

export const safeLoadJson = <T>(selector: string): T | null => {
    const el = document.querySelector(selector);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return el?.textContent ? JSON.parse(el.textContent) : null;
};
